/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2021-01-19 14:30:13
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-09-01 11:29:23
 */
import React, { useRef, useState } from 'react'
import axios from 'axios'
import { message, Radio, Input, Avatar, Checkbox } from 'antd'
import { connect } from 'react-redux'
import { sendmessagepublic } from '../../../../service/loginaction'
import { createGroup } from '../service/action'
import Search from 'antd/lib/input/Search'
import {gettalkListonline} from "src/service/loginaction_yunguan.js"
// ***********************************************************************************
// ****   ******   ********  *****************  ********   ****************   ********
// ****   **        *******  *********   *          ****   *         ******   ********
// *           ******              ****   ****  ********  **         ******   ********
// **   *      ******              *****            ***   ******    **               *
// ***  *  *   ******   ***  ***   ***********  *****        **   *********   ********
// *                *   ***  ***   **                **      **   ********   *********
// *           *  ***              ****  **************  *   **   ********         ***
// ****   **   *  ***   ***  ***   ****  **        ***   *           *****   ***  ****
// *           *  ***   ***  ***   ****  **  ****  ***      ***   *******     *   ****
// ****   **   *  ***              ****  **        ****     ***   ******      *   ****
// **          *  ***   ***  ***   ****      ****  *****    ***   *****    *     *****
// *           *  ***   ***  **********            ****      **   ****    ***    *****
// *          **  *********  *********    *  ****  ***   **  **   ***    **        ***
// ***    *   **  *********  **********  **  **    **   *****     ******     ****    *
// ***  ***  ***  *********  *******************  *********************** ************
// ***********************************************************************************
const AddGroup = (props) => {
    // const [friendlist, setUserList] = useState(props.friendList)
    const [selecteduser, selectuser] = useState([])
    const [selecteduserwithinfo, selectuserwithinfo] = useState([])
    const [searchtext, settext] = useState('')
    const [canClick, setCanClick] = useState(true)
    let groupNameRef = useRef()
    /**选择群组成员 */
    function onChange(value) {
        selectuser(value)
        let members = []
        value.forEach((id) => {
            let user = props.friendList.find((friend) => friend.userId === id)
            user && members.push(user)
        })
        selectuserwithinfo(members)
    }
    const getfrienduserinfo = (id) => {

    };
    const searchfriend = ({ target: { value } }) => {
        settext(value)
    };
    async function sendApp() {
        setCanClick(false)
        // debugger
        if (canClick) {
            let groupName = groupNameRef.current.state.value
            if (!groupName) {
                groupName = props.user.userName
                let namelength = selecteduserwithinfo.length < 3 ? selecteduserwithinfo.length : 3
                for (let index = 0; index < namelength; index++) {
                    const element = selecteduserwithinfo[index];
                    groupName += ',' + element.userName
                }
                if (selecteduserwithinfo.length > 3) {
                    groupName += '...'
                }
            }
            let response = await createGroup({
                "groupName": groupName,
                "groupAvatar": "https://img.zcool.cn/community/01a3865ab91314a8012062e3c38ff6.png@1280w_1l_2o_100sh.png",
                "groupDesc": "未添加群描述信息",
                "groupTags": "",
                "groupType": "",
                "groupOwnerId": props.user.userId,
                "groupOwnerName": props.user.userName,
                "members": selecteduserwithinfo
            })
            switch (response.code) {
                case '200':
                    message.success('建群成功！')
                    // window.location.reload()
                    gettalkListonline(props.user.userId)
                    let groupinfo = response.payload
                    sendmessagepublic({
                        url: '/group/' + groupinfo.groupId,
                        content: '群已经建成，大家可以自由聊天了！',
                        type: 'message',
                    })
                    onChange([])
                    break;
                case '500':
                    message.error('建群失败，请重试！')
                    break;
            }
            props.close()
            setCanClick(true)
        }
    }
    return (<div className='chat-addfriend-panel'>
        <Search className='addgroup-search common-search'
            onChange={searchfriend} placeholder='搜索'></Search>
        <div className='chat-addfriend-list'>
            <Checkbox.Group onChange={onChange} value={selecteduser}>
                {props.friendList.map((user, index) => {
                    // debugger
                    // return (<div key={user.userId} >
                    return (<div key={user.userId}
                        style={{ display: user.userName && user.userName.indexOf(searchtext) != -1 ? 'block' : 'none' }}
                    >

                        <Checkbox key={user.userId} value={user.userId} data={user} className='chat-addfriend-entity' >
                            <Avatar size={28} shape="square" src={global.yunguanAvatar + user.avatar} className={'chat-addfriend-avatar'}></Avatar>
                            <div className='chat-addfriend-entity-nametext' >{user.userName} </div>
                        </Checkbox>
                        <div className='chat-addfriend-entity-divider' > </div>
                    </div>
                    )
                })}
            </Checkbox.Group>
        </div>
        <div className='chat-addfriend-divider'></div>
        <div className='chat-addfriend-right'>
            <div className='chat-addgroup-text'>群组名称</div>
            <Input className='chat-addgroup-groupname' ref={groupNameRef} placeholder='请输入群组名称'></Input>
            <div className='chat-addgroup-text' >群组成员<span className='chat-addgroup-text2'>已选择 {selecteduser.length} 人</span></div>
            <div className='chat-addfriend-selected'>
                <Checkbox.Group onChange={onChange} value={selecteduser}>
                    {props.friendList.map((user, index) => {
                        return (<div key={user.userId} style={{ display: selecteduser.indexOf(user.userId) != -1 ? 'block' : 'none' }}>
                            <Checkbox value={user.userId} data={user} className='chat-addfriend-entity' >
                                <Avatar size={28} shape="square" src={global.yunguanAvatar + user.avatar} className={'chat-addfriend-avatar'}></Avatar>
                                <div className='chat-addfriend-entity-nametext' >{user.userName} </div>
                            </Checkbox>
                            <div className='chat-addfriend-entity-divider' > </div>
                        </div>
                        )
                    })}
                </Checkbox.Group>
            </div>
        </div>
        <div className='chat-addfriend-bottom'>
            <div className='chat-addfriend-cancel'
                onClick={() => { props.close() }}
            >         {"取消"}  </div>
            <div className='chat-addfriend-add'
                onClick={sendApp}
            > {"新建群组"}      </div>  </div>
    </div >)

}

const mapState = state => ({
    friendList: state.userReducer.get('friendList').toJS(),
    user: state.userReducer.get('user').toJS(),
})

const mapDispatch = dispatch => ({
})

export default connect(
    mapState,
    mapDispatch
)(AddGroup)

// export default AddGroup